<template>
  <div
    v-if="filteredCategories?.length"
    :class="cn('flex flex-col gap-1', props.class)"
  >
    <FilterSingle
      v-for="item in filteredCategories"
      :key="item.id"
      :label="item.name"
      :selected="item.id === selectedCategory?.id"
      icon="checkmark-default"
      @click="handleSelect(item)"
    />
  </div>
  <div v-else :class="cn('flex justify-center items-center', props.class)">
    <State
      type="Categories"
      :title="
        !isEmpty(categories)
          ? t('components.state.no_results.title')
          : t('components.state.no_categories.title')
      "
      :text="
        !isEmpty(categories)
          ? t('components.state.no_results.text')
          : t('components.state.no_categories.text')
      "
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { isEqual, sortBy, isEmpty } from "lodash";
import { FilterSingle } from "@/SharedComponents/Filters";
import { useCategories } from "@/Composables/useCategories";
import { State } from "@/SharedComponents/State";
import { cn } from "@/Utils/cn";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["submit"]);

const props = defineProps({
  initialState: { type: Object, default: () => ({}) },
  buildingIds: { type: Array, required: false },
  query: { type: String, required: false },
  class: { type: null, required: false },
});

// Translations
const { t } = useI18n();

const selectedCategory = ref(props.initialState);
const { isLoading, data } = useCategories(props.buildingIds);

const categories = computed(() => {
  if (isLoading.value) {
    return [];
  }
  if (props.buildingIds?.length === 1) {
    return data.value[props.buildingIds[0]];
  }
  return data.value;
});

const filteredCategories = computed(() => {
  if (!props.query) {
    return categories.value;
  }
  return categories.value.filter((category) => {
    return category.name.toLowerCase().includes(props.query);
  });
});

function handleSelect(category) {
  if (selectedCategory.value?.id === category?.id) {
    selectedCategory.value = {};
    return;
  }
  selectedCategory.value = category;
}

const isDirty = computed(() => {
  return !isEqual(sortBy(selectedCategory.value), sortBy(props.initialState));
});

function reset() {
  selectedCategory.value = props.initialState;
}

function submit() {
  if (!isDirty.value) {
    return;
  }
  emit("submit", selectedCategory.value);
}

defineExpose({
  isDirty,
  reset,
  submit,
});
</script>
